class SearchTemplate {
    constructor({ render }) {
        this.render = render;    
    }
}